import { TranslationMessages } from "ra-core";

const portugueseMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Mais filtros",
      add: "Add",
      back: "Voltar",
      bulk_actions: "1 item selecionado |||| %{smart_count} itens selecionados",
      cancel: "Cancelar",
      clear_array_input: "Limpar lista",
      clear_input_value: "Limpar valor",
      clone: "Clone",
      confirm: "Confirmar",
      create: "Criar",
      create_item: "Criar %{item}",
      delete: "Deletar",
      edit: "Editar",
      export: "Exportar",
      list: "Listar",
      refresh: "Recarregar",
      remove_filter: "Remover esse filtro",
      remove_all_filters: "Remover todos os filtros",
      remove: "Remover",
      save: "Salvar",
      search: "Pesquisar",
      select_all: "Select all",
      select_all_button: "Select all",
      select_row: "Select this row",
      show: "Show",
      sort: "Ordenar",
      undo: "Undo",
      unselect: "Unselect",
      expand: "Expand",
      close: "Close",
      open_menu: "Open menu",
      close_menu: "Close menu",
      update: "Update",
      move_up: "Move up",
      move_down: "Move down",
      open: "Open",
      toggle_theme: "Toggle light/dark mode",
      select_columns: "Columns",
      update_application: "Reload Application",
    },
    boolean: {
      true: "Yes",
      false: "No",
      null: " ",
    },
    page: {
      create: "Create %{name}",
      dashboard: "Dashboard",
      edit: "%{name} %{recordRepresentation}",
      error: "Something went wrong",
      list: "%{name}",
      loading: "Loading",
      not_found: "Not Found",
      show: "%{name} %{recordRepresentation}",
      empty: "Nenhum %{name} ainda.",
      invite: "Deseja adicionar um?",
      access_denied: "Access denied",
      authentication_error: "Authentication error",
    },
    input: {
      file: {
        upload_several: "Drop some files to upload, or click to select one.",
        upload_single: "Drop a file to upload, or click to select it.",
      },
      image: {
        upload_several: "Drop some pictures to upload, or click to select one.",
        upload_single: "Drop a picture to upload, or click to select it.",
      },
      references: {
        all_missing: "Unable to find references data.",
        many_missing:
          "At least one of the associated references no longer appears to be available.",
        single_missing:
          "Associated reference no longer appears to be available.",
      },
      password: {
        toggle_visible: "Hide password",
        toggle_hidden: "Show password",
      },
      autocomplete: {
        no_options: "Nenhum resultado encontrado",
      },
    },
    message: {
      about: "About",
      access_denied: "You don't have the right permissions to access this page",
      are_you_sure: "Are you sure?",
      authentication_error:
        "The authentication server returned an error and your credentials could not be checked.",
      auth_error:
        "An error occurred while validating the authentication token.",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title: "Update %{name} |||| Update %{smart_count} %{name}",
      clear_array_input: "Tem certeza que deseja limpar a lista inteira?",
      delete_content: "Are you sure you want to delete this item?",
      delete_title: "Delete %{name} #%{id}",
      details: "Details",
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: "O formulário contém erros. Por favor, verifique",
      loading: "Please wait",
      no: "No",
      not_found: "Either you typed a wrong URL, or you followed a bad link.",
      select_all_limit_reached:
        "There are too many elements to select them all. Only the first %{max} elements were selected.",
      unsaved_changes:
        "Some of your changes weren't saved. Are you sure you want to ignore them?",
      yes: "Yes",
    },
    navigation: {
      clear_filters: "Clear filters",
      no_filtered_results: "Nenhum resultado encontrado",
      no_results: "Nenhum resultado encontrado",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Go to page %{page}",
      first: "Go to first page",
      last: "Go to last page",
      next: "Go to next page",
      previous: "Go to previous page",
      page_rows_per_page: "Linhas por página:",
      skip_nav: "Skip to content",
    },
    sort: {
      sort_by: "Ordenar por %{field} %{order}",
      ASC: "asc",
      DESC: "desc",
    },
    auth: {
      auth_check_error: "Please login to continue",
      user_menu: "Profile",
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      sign_in_error: "Authentication failed, please retry",
      logout: "Logout",
    },
    notification: {
      updated: "Elemento atualizado |||| %{smart_count} elementos atualizados",
      created: "Elemento criado",
      deleted: "Elemento deletado |||| %{smart_count} elementos deletados",
      bad_item: "Elemento incorreto",
      item_doesnt_exist: "Elemento não existe",
      http_error: "Erro de comunicação com o servidor",
      data_provider_error: "dataProvider error. Check the console for details.",
      i18n_error: "Cannot load the translations for the specified language",
      canceled: "Ação cancelada",
      logged_out: "Sua sessão terminou, por favor reconecte",
      not_authorized: "You're not authorized to access this resource.",
      application_update_available: "Uma nova versão está disponível.",
    },
    validation: {
      required: "Obrigatório",
      minLength: "Deve ter pelo menos %{min} caracteres",
      maxLength: "Deve ter no máximo %{max} caracteres",
      minValue: "Valor mínimo: %{min}",
      maxValue: "Valor máximo: %{max}",
      number: "Deve ser um número",
      email: "Deve ser um email válido",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
      unique: "Must be unique",
    },
    saved_queries: {
      label: "Saved queries",
      query_name: "Query name",
      new_label: "Save current query...",
      new_dialog_title: "Save current query as",
      remove_label: "Remove saved query",
      remove_label_with_name: 'Remove query "%{name}"',
      remove_dialog_title: "Remove saved query?",
      remove_message:
        "Are you sure you want to remove that item from your list of saved queries?",
      help: "Filter the list and save this query for later",
    },
    configurable: {
      customize: "Customize",
      configureMode: "Configure this page",
      inspector: {
        title: "Inspector",
        content: "Hover the application UI elements to configure them",
        reset: "Reset Settings",
        hideAll: "Hide All",
        showAll: "Show All",
      },
      Datagrid: {
        title: "Datagrid",
        unlabeled: "Unlabeled column #%{column}",
      },
      SimpleForm: {
        title: "Form",
        unlabeled: "Unlabeled input #%{input}",
      },
      SimpleList: {
        title: "List",
        primaryText: "Primary text",
        secondaryText: "Secondary text",
        tertiaryText: "Tertiary text",
      },
    },
  },
  menu: {
    skucmms: "CMM por loja",
    scmconfigs: "Configuração",
    skurankings: "Rankings SKU",
  },
  resources: {
    buyers: {
      name: "Comprador |||| Compradores",
      fields: {
        id: "ID",
        nome_razao: "Razão Social",
        nome_fantasia: "Nome Fantasia",
        email: "E-mail",
        seg: "Segunda",
        ter: "Terça",
        qua: "Quarta",
        qui: "Quinta",
        sex: "Sexta",
        sab: "Sábado",
        total: "Total",
      },
    },
    scmconfigs: {
      name: "Configuração |||| Configurações",
    },
    skurankings: {
      name: "Ranking de MOS",
      fields: {
        id: "ID",
        prod_xprod: "Descrição",
        nome_fornec: "Fornecedor",
        cmm: "CMM",
        expo: "Expo",
        er: "ER",
        mos: "MOS",
      },
    },
    notifications: {
      name: "Notificações",
      fields: {
        id: "ID",
        titulo_notificacao: "Título Notificação",
        sigla_modulo: "Módulo",
        usu_criador: "Criador",
        data_hora: "Data/Hora",
        nao_lida: "Não Lida",
      },
    },
    suppliercontacts: {
      name: "Contato |||| Contatos",
      fields: {
        id: "ID",
        nome_contato: "Nome",
        desc_tipo: "Tipo",
        tipo: "Tipo",
        id_pessoa: "Pessoa",
        email: "E-mail",
        telefone: "Telefone",
        cpf: "CPF",
        sexo: "Sexo",
        type_id: "Tipo de telefone",
        observacoes: "Observações",
        ativo: "Ativo",
        relacionamento: {
          autorizado: "Autorizado a comprar",
        },
      },
    },
    skucmms: {
      name: "CMM por loja |||| CMM por loja",
      fields: {
        id: "ID",
        sigla_loja: "Sigla",
        dias_estoq: "Dias Estoq",
        quant_mes: "Quant/Mês",
        ticket_mes: "Ticket/Mês",
        valor_mes: "Valor/Mês",
        qtd_natural: "Qtd Natural",
        sazo_efet: "Sazo Efet",
        codigo_sku: "Cód. SKU",
        expo: "Expo",
        cmmf_quant: "CMMF Quant",
        cmmf_validade: "CMMF Validade",
      },
    },
  },
};

export default portugueseMessages;
